// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import Icon_facebook from '../../img/icons/20/facebook.svg';
import Icon_twitter_x from '../../img/icons/20/twitter_x.svg';
import Icon_linkedin from '../../img/icons/20/linkedin.svg';
import Icon_link from '../../img/icons/20/link.svg';
import styles from './share.module.less';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';

export const Share = ()=>{
    const {params} = use_pathname();
    const param = params['blog'];
    const current_url = `https://oculusproxies.com/blog/${param}`;
    const page_title = document.title;
    const encoded_title = encodeURIComponent(page_title);
    const encoded_url = encodeURIComponent(current_url);
    const x_link = `https://twitter.com/intent/tweet?text=${encoded_title}`
        +`&url=${encoded_url}`;
    const facebook_link = `https://www.facebook.com/sharer/sharer.php?`
        +`u=${encoded_url}`;
    const linkedin_link = `https://www.linkedin.com/sharing/share-offsite/?`
        +`url=${encoded_url}`;
    const copy = ()=>{
        void navigator.clipboard.writeText(current_url)
            .then(()=>alert(`Copied!`));
    };
    return <div className={styles.social_share}>
      <a href={x_link} target='_blank' rel='noopener noreferrer'
        className={styles.social_button}>
        <Icon_twitter_x width={20} height={20} />
      </a>
      <a href={linkedin_link} target='_blank' rel='noopener noreferrer'
        className={styles.social_button}>
        <Icon_linkedin width={20} height={20} />
      </a>
      <a href={facebook_link} target='_blank' rel='noopener noreferrer'
        className={styles.social_button}>
        <Icon_facebook width={20} height={20} />
      </a>
      <div onClick={copy} className={styles.social_button}>
        <Icon_link width={20} height={20} />
      </div>
    </div>;
};
